import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXAIChatHistory implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAIChatHistoryContainer";
    }
    render(){
        let self=this;
    }
}